export class UploadQueue {
  constructor(maxConcurrent = 5, maxRetries = 5) {
    this.queue = [];
    this.active = new Set();
    this.maxConcurrent = maxConcurrent;
    this.maxRetries = maxRetries;
    this.processing = false;
  }

  async add(upload) {
    return new Promise((resolve, reject) => {
      const uploadItem = {
        ...upload,
        retryCount: 0,
        resolve,
        reject,
        uploadState: {},
      };
      this.queue.push(uploadItem);

      if (!this.processing) {
        this.processing = true;
        this.processQueue();
      }
    });
  }

  async processQueue() {
    try {
      while (this.queue.length > 0 || this.active.size > 0) {
        if (this.active.size >= this.maxConcurrent) {
          await Promise.race([...this.active].map(item => item.promise));
          continue;
        }

        if (this.queue.length === 0) {
          await Promise.all([...this.active].map(item => item.promise));
          continue;
        }

        const upload = this.queue.shift();
        const promise = this.processUpload(upload);
        upload.promise = promise;
        this.active.add(upload);
      }
    } finally {
      this.processing = false;
    }
  }

  async processUpload(upload) {
    try {
      const result = await upload.uploadFn(upload.uploadState);
      upload.resolve(result);
      return result;
    } catch (error) {
      if (upload.uploadState.documentId) {
        await upload.deleteDocumentFn(upload.uploadState);
        upload.uploadState.documentId = null;
      }

      if (upload.retryCount < this.maxRetries - 1) {
        upload.retryCount++;
        this.queue.push(upload);
      } else {
        upload.reject(error);
      }
    } finally {
      this.active.delete(upload);
    }
  }
}
